type ExperimentParameters = Record<string, string>;
export type ExperimentDefinition = readonly [string, ExperimentParameters];
export type ExperimentDefinitions = Record<string, ExperimentDefinition>;

export const ExperimentLayers = {
  Measures: [
    'telehealth_measures',
    {
      ShouldShowClientMeasures: 'shouldShowClientMeasures',
      ShouldShowProviderMeasures: 'shouldShowProviderMeasures',
    },
  ],
  PruneGraceMultiplier: [
    'telehealth_prune_grace_multiplier_experiment',
    {
      pruneGraceMultiplier: 'pruneGraceMultiplier',
    },
  ],
  Admission: [
    'telehealth_admission',
    {
      systemNotificationsAreEnabled: 'systemNotificationsAreEnabled',
    },
  ],
  FollowUpScheduling: [
    'follow_up_scheduling',
    {
      shouldSeeFollowUpNudge: 'shouldSeeFollowUpNudge',
      shouldSeeWaitingRoomScheduleCta: 'shouldSeeWaitingRoomScheduleCta',
    },
  ],
  ProviderUtilization: [
    'provider_utilization',
    {
      providerUtilizationVariant: 'providerUtilizationVariant',
    },
  ],
} as const satisfies ExperimentDefinitions;
